import React from 'react';

import { MeasurementFieldType, TVoltageUnit, voltageConverter } from 'models';

import type { MeasurementInputWrapperProps } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { MeasurementInputWrapper } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { UnitWithTooltip } from 'components/forms/fields/measurement/Unit';
import { useMultiUnitMeasurementController } from 'components/forms/fields/measurement/useMultiUnitMeasurementController';
import { useRenderVariableMultiInput } from 'components/forms/fields/measurement/useRenderVariableMultiInput';

export type VoltageFieldProps = {
    name: string;
    fields?: MeasurementFieldType[];
    hideIcons?: boolean;
    placeholder?: string;
    disabled?: boolean;
    defaultUnit?: TVoltageUnit;
} & MeasurementInputWrapperProps;

const VoltageField = ({
    name,
    fields = ['min', 'nom', 'max'],
    hideIcons,
    placeholder,
    disabled,
    defaultUnit,
    ...wrapperProps
}: VoltageFieldProps) => {
    const {
        unit,
        cycleUnit,
        fields: fieldsRecord,
    } = useMultiUnitMeasurementController({
        name,
        converter: voltageConverter,
        defaultUnit,
        fields,
    });

    const extraProps: any = {
        hideIcon: hideIcons,
        size: wrapperProps.size,
        disabled,
    };

    if (placeholder) {
        extraProps.placeholder = placeholder;
    }

    const Unit = <UnitWithTooltip onClick={cycleUnit}>{unit}</UnitWithTooltip>;
    const Fields = useRenderVariableMultiInput({
        fields,
        fieldsRecord,
        Unit,
        extraProps,
    });

    return <MeasurementInputWrapper {...wrapperProps}>{Fields}</MeasurementInputWrapper>;
};

export { VoltageField };
